import { render, staticRenderFns } from "./posologie.vue?vue&type=template&id=d8d8d53c&"
import script from "./posologie.vue?vue&type=script&lang=js&"
export * from "./posologie.vue?vue&type=script&lang=js&"
import style0 from "./posologie.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports